/**
 * The browser's folder picker and share sheet as backups use them (decision 72; part 24e log, tables P, M7). TypeScript's
 * DOM library doesn't declare `showDirectoryPicker`, and which browsers can share a file is known only by asking, so
 * both are read by shape here: a browser without them gets null, and backups take the reminder's download instead.
 */

/** The picker's ID: the browser opens it where the writer last picked a backup folder. */
export const PICKER_ID = 'cockatrice-backups';

/** P1–P3: a function opening the folder picker for reading and writing, or null where the page has none (P4–P7). */
export function folderPicker(scope: object): (() => Promise<unknown>) | null {
  const picker: unknown = Reflect.get(scope, 'showDirectoryPicker');
  if (typeof picker !== 'function') return null;
  return () => Promise.resolve(Reflect.apply(picker, scope, [{ id: PICKER_ID, mode: 'readwrite' }]));
}

/**
 * M7: a function sharing a file, or null where files can't be shared, or where the pointer is fine (a desktop's share
 * sheet offers no way to keep a file, so the reminder downloads there).
 */
export function fileSharer(navigator: object, coarse: boolean): ((file: File) => Promise<void>) | null {
  const share: unknown = Reflect.get(navigator, 'share');
  const canShare: unknown = Reflect.get(navigator, 'canShare');
  if (!coarse || typeof share !== 'function' || typeof canShare !== 'function') return null;
  const probe = { files: [new File([], 'backup.zip', { type: 'application/zip' })] };
  if (Reflect.apply(canShare, navigator, [probe]) !== true) return null;
  return async (file) => {
    await Promise.resolve(Reflect.apply(share, navigator, [{ files: [file] }]));
  };
}
